import { render, staticRenderFns } from "./AppDurationLink.vue?vue&type=template&id=1a94c1eb&"
import script from "./AppDurationLink.vue?vue&type=script&lang=js&"
export * from "./AppDurationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports